<div id="main" fxLayout="column" fxLayoutAlign="start center">

  <div id="title" class="upload-title">
    Upload files below
  </div>

  <span class="decription layout padding-vertical">Upload relevant files and select the document category from the dropdown field.</span>

  <uppy-dashboard [uppy]="uppy" [props]="uppyDashboardOptions"></uppy-dashboard>

  <div id="footer">
    <mat-form-field appearance="outline">
      <mat-label>Category</mat-label>
      <mat-select [(ngModel)]="selectedCategory" (selectionChange)="onCategoryChange()">
        <mat-option *ngFor="let category of applicationCategories" [value]="category.value">{{category.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="actions">
      <button mat-button (click)="cancel()">CANCEL</button>
      <button mat-flat-button color="primary" [disabled]="!valid" (click)="submit()">SUBMIT</button>
    </div>
  </div>

</div>
